const UnionIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={29} height={25} fill="none" {...props}>
    <path
      fill="#312F4F"
      fillRule="evenodd"
      d="M0 .935h24a4.23 4.23 0 0 1 4.235 4.235V20.7H14.118l-4.236 4.235L5.647 20.7H0V.935Zm14.118 16.941h11.28V5.17c0-.776-.636-1.411-1.412-1.411H2.809v14.117H6.805l.833.833 2.244 2.245 2.245-2.245.819-.833h1.172ZM9.855 10.82a1.412 1.412 0 1 1-2.824 0 1.412 1.412 0 0 1 2.824 0Zm4.213 1.412a1.412 1.412 0 1 0 0-2.823 1.412 1.412 0 0 0 0 2.823Zm7.13-1.412a1.412 1.412 0 1 1-2.823 0 1.412 1.412 0 0 1 2.823 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export { UnionIcon };
